<template lang="pug">
    transition-group(tag="div" name="wrapper" class="wrapper" :style="dropdown")
        div(v-if="mode === 'summary'" ref="summary" key="summary")
            span(v-if="!value.length")
                | No filters applied.

            div(v-else)
                .filter-display(v-for="(f, i) in value" )
                    .filter-name(@click="editFilter(f)") {{ f.display_name }}
                    a.nav-link.text-muted(@click="removeFilter(f, i)")
                        i.material-icons.md-18 &#xe14c;

        div(v-if="mode === 'selectFilter'" ref="selectFilter" key="selectFilter")
            .form-group
                input.form-control(
                    autofocus
                    v-focus=""
                    type="search"
                    placeholder="Search..."
                    v-model="query"
                    @keyup.enter="selectFilterFromSearch"
                )

            .filter
                .filter-group(v-for="(g, i) in groupedFilters")
                    span.group-name {{ i }}
                    .filter-list
                        a.filter-item(
                            v-for="f in g"
                            :class="f.disabled ? 'not-allowed text-muted' : null"
                            @click="f.disabled ? false : selectFilter(f)"
                        )
                            | {{ f.display_name }}

        div(v-if="mode === 'selectOperator'" ref="selectOperator" key="selectOperator")
            a.selected-filter.info.r.m-b-1(@click="clearFilter()")
                | {{ selectedFilter.display_name }}

            .form-group
                input.form-control(
                    autofocus
                    v-focus=""
                    type="search"
                    placeholder="Search..."
                    v-model="query_operator"
                    @keyup.enter="selectOperatorFromSearch"
                )

            .filter
                .filter-list
                    a.filter-item(v-for="o in filteredOperators" @click="selectOperator(o)")
                        | {{ o.display_name }}

        div(v-if="mode === 'selectOperatorValue'" ref="selectOperatorValue" key="selectOperatorValue")
            a.selected-filter.info.r.m-b-1(@click="clearOperator()")
                | {{ selectedFilter.display_name }} {{ selectedOperator.display_name }}

            .form-group.loading-holder
                input.form-control(
                    autofocus
                    v-focus=""
                    type="search"
                    placeholder="Search..."
                    v-model="query_display"
                    v-if="operatorType === 'list' || operatorType === 'multiselect'"
                    @keyup.enter="selectOperatorValueFromSearch"
                )

                .loading(v-if="remote_loading")
                    .loading-spinner

            input.m-b-0.form-control(
                autofocus
                v-focus=""
                v-if="operatorType === 'number'"
                type="number"
                v-model="operatorValue"
                @keyup.enter="selectOperatorValueFromSearch"
            )

            input.m-b-0.form-control(
                autofocus
                v-focus=""
                v-if="operatorType === 'number_with_validation'"
                type="number"
                min="0"
                v-model="operatorValue"
                @keyup.enter="selectOperatorValueFromSearch"
            )

            input.m-b-0.form-control(
                autofocus
                v-focus=""
                v-if="operatorType === 'text'"
                type="text"
                v-model="operatorValue"
                @keyup.enter="selectOperatorValueFromSearch"
            )
            input.m-b-0.form-control(
                autofocus
                v-focus=""
                v-if="operatorType === 'text_with_placeholder'"
                type="text"
                placeholder="0-100"
                title="Please enter a valid range (e.g., 0-100)" 
                v-validate="'regex:/^[0-9]{1,4}-[0-9]{1,4}$/'"
                v-model="operatorValue"
                @keyup.enter="selectOperatorValueFromSearch"
            )

            .filter.m-t-1(v-if="operatorFilters.length")
                .checkbox-list(v-if="operatorType === 'list'")
                    p(v-for="v in operatorFilters")
                        label.md-check
                            input(
                                type="radio"
                                v-model="operatorValue"
                                :value="v"
                            )
                            i.indigo

                            .item-wrapper
                                slot(:name="selectedFilter.name" v-bind:value="v")
                                    | {{ v.display_name }}

                .multiselect-filter(v-if="operatorType === 'multiselect'")
                    p(v-if="!noSelectAllCheckbox.includes(selectedFilter.display_name)")
                        label.md-check
                            input(
                                type="checkbox"
                                v-model="allSelected"
                                @change="selectAll"
                            )
                            i.indigo

                            .item-wrapper
                                | Select All
                    p(v-for="v in operatorFilters")
                        label.md-check
                            input(
                                type="checkbox"
                                v-model="operatorList"
                                :value="v"
                                @change="select"
                            )
                            i.indigo

                            .item-wrapper
                                slot(:name="selectedFilter.name" v-bind:value="v")
                                    | {{ v.display_name }}

            p.m-b-0(v-if="shouldShowNoItems") No item found.
</template>

<script>
export default {
    props: {
        filters: {
            type: Array,
            required: true,
        },

        externalRemotes: {
            type: Object,
            required: false,
            default: () => {},
        },

        value: {
            type: Array,
            required: false,

            default() {
                return [];
            },
        },

        preSelectOperator: {
            type: Boolean,
            required: false,
            default: false,
        },

        preSelectOperatorData: {
            type: Object,
            required: false,

            default() {
                return {
                    name: 'includes',
                    display_name: 'includes',
                    type: 'multiselect',
                };
            },
        },

        returnOperatorValueList: {
            type: Boolean,
            required: false,
            default: false,
        },

        noSelectAllCheckbox: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            dropdown: { height: 0 },
            mode: 'none',
            operatorValue: null,
            operatorList: [],
            operatorListValues: [],
            query: null,
            selectedFilter: null,
            selectedOperator: null,
            query_display: null,
            query_operator: null,
            remote_loading: false,
            allSelected: false,
            editingFilter: null,
        };
    },

    computed: {
        filteredFilters() {
            this.filters.map(f => delete f.disabled);

            let operands = this.value.map(v => v.operand);

            let filteredFilters = this.filters.map(f => {
                if (f.disabled_if != null) {
                    f.disabled_if.map(d => {
                        if (operands.includes(d)) {
                            f['disabled'] = true;
                        }
                    });
                }

                return f;
            });

            if (!!this.query) {
                filteredFilters = _.filter(this.filters, f =>
                    f.display_name
                        .toLowerCase()
                        .includes(this.query.toLowerCase()),
                );
            }

            return filteredFilters;
        },

        filteredOperators() {
            let filteredOperators = this.selectedFilter.operators;

            if (!!this.query_operator) {
                filteredOperators = _.filter(this.selectedFilter.operators, f =>
                    f.display_name
                        .toLowerCase()
                        .includes(this.query_operator.toLowerCase()),
                );
            }

            return filteredOperators;
        },

        generatedFilter() {
            if (!this.selectedFilter || !this.selectedOperator) {
                return null;
            }

            const operand = this.selectedFilter.name;
            const operator = this.selectedOperator.name;
            const type = this.selectedOperator.type;

            const onn = this.selectedFilter.display_name;
            const otn = this.selectedOperator.display_name;

            const opv = this.operatorValue;
            const opl = this.operatorList;

            const filter = {
                operand,
                operator,
            };

            if (this.returnOperatorValueList) {
                filter.filter_name = onn;
                filter.opl = opl;
                filter.opv = opv;
                filter.allSelected = this.allSelected;
            }

            if (!!opv || type === 'none') {
                switch (type) {
                    case 'list':
                        const v = opv.id;
                        const n = opv.display_name;

                        filter.display_name = `${onn} ${otn} ${n}`;
                        filter.value = v;

                        return filter;

                    case 'text':
                    case 'text_with_placeholder':
                    case 'number_with_validation':
                    case 'number':
                        filter.display_name = `${onn} ${otn} ${opv}`;
                        filter.value = opv;

                        return filter;

                    case 'none':
                        filter.display_name = `${onn} ${otn}`;

                        return filter;
                }
            }

            if (!!opl) {
                switch (type) {
                    case 'multiselect':
                        filter.display_name = `${onn} ${otn} ${
                            opl.length
                        } items`;

                        filter.list = opl.map(l => l.id);

                        return filter;
                }
            }

            return null;
        },

        groupedFilters() {
            return _.groupBy(this.filteredFilters, 'group_display_name');
        },

        isRemoteOperatorValue() {
            return !!this.selectedFilter.remote;
        },

        operatorFilters() {
            let filteredOperator = this.operatorListValues;

            if (!!this.query_display) {
                filteredOperator = _.filter(this.operatorListValues, f =>
                    f.display_name
                        .toLowerCase()
                        .includes(this.query_display.toLowerCase()),
                );
            }

            return filteredOperator;
        },

        operatorType() {
            if (!!this.selectedOperator) {
                return this.selectedOperator.type;
            }

            return null;
        },

        remoteOperatorValueName() {
            const remote = this.selectedFilter.remote;

            if (remote) {
                if (remote.external) {
                    return remote.name;
                }
            }

            return null;
        },

        shouldShowNoItems() {
            const remoteItems = ['list', 'multiselect'];

            return (
                !this.remote_loading &&
                !this.operatorFilters.length &&
                remoteItems.includes(this.operatorType)
            );
        },
    },

    watch: {
        mode(index, from) {
            if (index === from) return;
            this.updateHeight(index);
        },

        query_display(to, from) {
            if (this.remoteOperatorValueName) {
                this.refreshExternalRemoteData(
                    this.remoteOperatorValueName,
                    to,
                );
            }
        },
    },

    created() {
        this.preloadExternalRemoteData();
    },

    mounted() {
        this.mode = 'summary';
    },

    methods: {
        applyFilter() {
            const e = [...this.value];

            if (this.editingFilter) {
                const i = e.indexOf(this.editingFilter);

                if (i > -1) {
                    e.splice(i, 1);
                }

                this.editingFilter = null;
            }

            e.push(this.generatedFilter);
            this.$emit('input', e);
            this.showSummary();

            this.$emit('filter-created', this.generatedFilter);
            this.reset();

            if (!_.isNull(this.$store.getters.activeTableName)) {
                this.setActiveTableFilters(e);
            }
        },

        clearFilter() {
            this.mode = 'selectFilter';
            this.selectedFilter = null;
        },

        clearOperator() {
            this.mode = 'selectOperator';
            this.selectedOperator = null;
        },

        createFilter() {
            this.mode = 'selectFilter';
        },

        async editFilter(f) {
            this.$emit('filter-edit', f);

            let operand = this.filters.find(o => o.name === f.operand);
            let operator = operand.operators.find(o => o.name === f.operator);

            this.selectedFilter = operand;
            this.selectedOperator = operator;

            const remote = operand.remote;

            if (remote) {
                if (remote.external) {
                    await this.loadExternalRemoteData(remote.name);
                }
            }

            if (f.list) {
                this.operatorList = f.list.map(l =>
                    this.operatorListValues.find(v => v.id === l),
                );
            }

            if (f.value) {
                this.operatorValue = this.operatorListValues.find(
                    v => v.id === f.value,
                );
            }

            if (f.allSelected) {
                this.allSelected = true;
            }

            this.editingFilter = f;
            this.mode = 'selectOperatorValue';
        },

        loadExternalRemoteData(name, query = null) {
            const func = this.externalRemotes[name];

            if (func) {
                const promise = func(query);
                this.remote_loading = true;
                this.updateHeight('selectOperatorValue');

                return promise.then(data => {
                    this.operatorListValues = data;
                    this.updateHeight('selectOperatorValue');
                    this.remote_loading = false;
                });
            }

            return Promise.resolve();
        },

        preloadExternalRemoteData() {
            Object.keys(this.externalRemotes).forEach(r => {
                this.externalRemotes[r](null);
            });
        },

        refreshExternalRemoteData: _.debounce(function(name, query = null) {
            this.loadExternalRemoteData(name, query);
        }, 500),

        removeFilter(f, i) {
            const e = [...this.value];
            e.splice(i, 1);

            this.$emit('input', e);
            this.$emit('filter-deleted', f);

            this.updateHeight('summary');

            if (!_.isNull(this.$store.getters.activeTableName)) {
                this.setActiveTableFilters(e);
            }

            this.$parent.clearTemporaryFilters();
        },

        reset() {
            this.operatorValue = null;
            this.operatorList = [];
            this.operatorListValues = [];
            this.query = null;
            this.query_display = null;
            this.query_operator = null;
            this.selectedFilter = '';
            this.selectedOperator = null;
        },

        selectFilter(f) {
            this.selectedFilter = f;

            if (this.preSelectOperator) {
                let pso;
                let def = f.operators.find(o => !!o.default);

                if (def) {
                    // Find default operator from meta
                    pso = def;
                } else {
                    // Get from filter component
                    const ps = this.preSelectOperatorData;

                    const exists = f.operators.some(o => {
                        return o.name === ps.name && o.type === ps.type;
                    });

                    if (exists) {
                        pso = ps;
                    }
                }

                if (pso) {
                    this.selectOperator(pso);
                } else {
                    this.mode = 'selectOperator';
                }
            } else {
                this.mode = 'selectOperator';
            }
        },

        selectFilterFromSearch() {
            if (this.query && this.filteredFilters.length) {
                this.selectFilter(this.filteredFilters[0]);
            }
        },

        selectOperator(o) {
            this.selectedOperator = o;

            if (o.type === 'none') {
                this.applyFilter();
                return;
            }

            const remote = this.selectedFilter.remote;

            if (remote) {
                if (remote.external) {
                    this.loadExternalRemoteData(remote.name);
                }
            }

            this.mode = 'selectOperatorValue';
        },

        selectOperatorFromSearch() {
            if (this.query_operator && this.filteredOperators.length) {
                this.selectOperator(this.filteredOperators[0]);
            }
        },

        selectOperatorValueFromSearch() {
            if (this.query_display && this.operatorFilters.length) {
                if (this.operatorType === 'list') {
                    this.operatorValue = this.operatorFilters[0];
                    this.validateAndApplyFilter();
                }
            }

            if (
                [
                    'text',
                    'number',
                    'text_with_placeholder',
                    'number_with_validation',
                ].includes(this.operatorType)
            ) {
                if (this.operatorValue) {
                    this.validateAndApplyFilter();
                }
            }
        },

        showSummary() {
            this.mode = 'summary';
        },

        updateHeight(index) {
            this.$nextTick(() => {
                if (!this.$refs[index]) return;

                this.dropdown.height = `${this.$refs[index].clientHeight}px`;
            });
        },

        validateAndApplyFilter() {
            if (
                !!this.generatedFilter &&
                ((this.generatedFilter.list &&
                    this.generatedFilter.list.length > 0) ||
                    this.generatedFilter.value)
            ) {
                this.applyFilter();
                return true;
            }

            return false;
        },

        selectAll: function() {
            this.operatorList = [];

            if (this.allSelected) {
                this.operatorFilters.map((value, key) => {
                    this.operatorList.push(this.operatorFilters[key]);
                });
            }
        },

        select: function() {
            this.allSelected = false;
        },

        setActiveTableFilters(filters) {
            localStorage.setItem(
                `${this.$store.getters.activeTableName}_filters`,
                JSON.stringify(filters),
            );
        },
    },
};
</script>

<style lang="scss" scoped>
.checkbox-list,
.multiselect-filter {
    .md-check {
        width: 100%;
    }

    p {
        margin-bottom: 0;
        padding: 6px;

        &:hover {
            background-color: rgba(0, 0, 0, 0.065);
        }
    }
}

.filter {
    max-height: 200px;
    overflow: auto;
}

.group-name {
    font-size: 12px;
    font-weight: bold;
    padding: 6px;
    text-transform: uppercase;
}

.filter-display {
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding: 6px;

    .filter-name {
        cursor: pointer;
        width: 100%;
    }

    a:hover {
        background-color: rgba(0, 0, 0, 0.13);
    }

    &:hover {
        background-color: rgba(0, 0, 0, 0.065);
    }
}

.filter-group {
    margin-bottom: 0.5rem;

    &:last-child {
        margin-bottom: 0;
    }
}

.filter-item {
    display: block;
    padding: 6px;

    &:hover {
        background-color: rgba(0, 0, 0, 0.065);
    }
}

.selected-filter {
    color: white;
    display: block;
    font-weight: bold;
    padding: 8px 6px;
}

.wrapper {
    overflow: hidden;
    transition: height 350ms;

    &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 1rem;
        background-image: linear-gradient(to top, white, rgba(white, 0));
    }

    &-enter,
    &-leave-to {
        opacity: 0;
    }

    &-leave,
    &-enter-to {
        opacity: 1;
    }

    &-enter-active,
    &-leave-active {
        position: absolute;
        width: calc(100% - 2rem);
        transition: opacity 200ms ease-in-out;
    }

    &-enter-active {
        transition-delay: 100ms;
    }
}

.item-wrapper {
    margin-left: 8px;
}

.loading {
    line-height: 1;
    position: absolute;
    right: 10px;
    text-align: center;
    top: 10px;
}

.loading-holder {
    position: relative;
}

.not-allowed {
    cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/filter/filter-list.vue